export default __webpack_public_path__ + "static/media/phone-calling.05b13eaa.mp3";